import { IBaseLLMTemplate } from '@/models/llmTemplate.model';
import { LLMTemplateFormFields, TLLMTemplateFormValues } from '@/modules/LLMTemplateCommon';

export const getLLMTemplateDetailsInitialValues = (template?: IBaseLLMTemplate | null): TLLMTemplateFormValues => ({
  [LLMTemplateFormFields.CONTENT]: template?.content || '',
});
